import { Layout, Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Navbar.scss';
export const isMobile = window.innerWidth < 500;

interface NavMonthsProps {
  year: string;
  month: number;
  hidden?: boolean;
  setMonth: (month: number) => void;
  setYear: (year: number) => void;
}

const NavMonths = ({ year, month, hidden = false, setMonth, setYear }: NavMonthsProps) => {
  const { t } = useTranslation();

  if (hidden) return;

  const handleChangeMonth = (op: 'sub' | 'add') => {
    let newShowMonth = month;
    let newYear = Number.parseInt(year);

    if (op === 'sub') {
      newShowMonth -= 1;
    }
    if (op === 'add') {
      newShowMonth += 1;
    }
    if (newShowMonth > 12) {
      newShowMonth = 1;
      newYear += 1;
    }
    if (newShowMonth < 1) {
      newShowMonth = 12;
      newYear -= 1;
    }
    setMonth(newShowMonth);
    setYear(newYear);
  };

  const menuItems = () => [
    {
      key: 0,
      label: (
        <Link to="/" onClick={() => handleChangeMonth('sub')}>
          {'<'}
        </Link>
      ),
    },
    {
      key: 1,
      label: (
        <Link to="/" onClick={() => setMonth(1)}>
          {t('months.jan')}
        </Link>
      ),
    },
    {
      key: 2,
      label: (
        <Link to="/" onClick={() => setMonth(2)}>
          {t('months.feb')}
        </Link>
      ),
    },
    {
      key: 3,
      label: (
        <Link to="/" onClick={() => setMonth(3)}>
          {t('months.mar')}
        </Link>
      ),
    },
    {
      key: 4,
      label: (
        <Link to="/" onClick={() => setMonth(4)}>
          {t('months.apr')}
        </Link>
      ),
    },
    {
      key: 5,
      label: (
        <Link to="/" onClick={() => setMonth(5)}>
          {t('months.may')}
        </Link>
      ),
    },
    {
      key: 6,
      label: (
        <Link to="/" onClick={() => setMonth(6)}>
          {t('months.jun')}
        </Link>
      ),
    },
    {
      key: 7,
      label: (
        <Link to="/" onClick={() => setMonth(7)}>
          {t('months.jul')}
        </Link>
      ),
    },
    {
      key: 8,
      label: (
        <Link to="/" onClick={() => setMonth(8)}>
          {t('months.aug')}
        </Link>
      ),
    },
    {
      key: 9,
      label: (
        <Link to="/" onClick={() => setMonth(9)}>
          {t('months.sep')}
        </Link>
      ),
    },
    {
      key: 10,
      label: (
        <Link to="/" onClick={() => setMonth(10)}>
          {t('months.oct')}
        </Link>
      ),
    },
    {
      key: 11,
      label: (
        <Link to="/" onClick={() => setMonth(11)}>
          {t('months.nov')}
        </Link>
      ),
    },
    {
      key: 12,
      label: (
        <Link to="/" onClick={() => setMonth(12)}>
          {t('months.dec')}
        </Link>
      ),
    },
    {
      key: 13,
      label: (
        <Link to="/" onClick={() => handleChangeMonth('add')}>
          <span>{'>'}</span>
        </Link>
      ),
    },
  ];
  return (
    <Layout style={{ background: 'transparent' }}>
      <Menu
        mode="horizontal"
        defaultSelectedKeys={[`${month}`]}
        items={menuItems()}
        style={{ textAlign: 'center' }}
        className="navbar navbar-sub"
      />
    </Layout>
  );
};

export default NavMonths;
